export const generateYearsOptions = () => {
  let yearsOptions = [{ value: "0", label: "UNKNOWN" }];

  const endYear = new Date().getFullYear();
  for (let year = endYear; year >= 1940; year--) {
    yearsOptions.push({ value: String(year), label: String(year) });
  }
  return yearsOptions;
};
